import React from 'react';
import styled from 'styled-components';
import useBrand from '../../hooks/useBrand';

const TabContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 0 auto;
  margin-bottom: 32px;
  align-items: center;
  justify-content: center;

  @media (min-width: 990px) {
    padding-top: 0;    
  }
`;

const TabItem = styled.div<{ $brand?: string }>`
  display: block;
  margin: 0 12px;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: var(--Primary-Asteroid, #888);
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: #EAEAEA;
    color: #1A1B1B;
    border-radius: 8px;
  }

  ${({ $brand }) => $brand == 'jackson' && `
    background: transparent;
    color: #000;
    border: 1px solid #000;
    border-radius: 0;

    &:hover {
      background: #000;
      color: #FFF;
      border-radius: 0;
    }
  `}
`;

const TabItemActive = styled(TabItem)<{ $brand?: string }>`
  background: #EAEAEA;
  color: #1A1B1B;
  border-radius: 8px;

  ${({ $brand }) => $brand == 'jackson' && `
    background: #000;
    color: #FFF;
    border-radius: 0;

    &:hover {
      border-radius: 0;
    }
  `}
`;

const DealerNavigation = styled.div<{ $brand?: string }>`
  margin: 7px 0 14px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    text-align: center;

    li {
      display: inline-block;

      a {
        display: block;
        margin: 0 12px;
        padding: 14px 16px;
        font-size: 16px;
        font-style: normal;
        line-height: 20px;
        letter-spacing: 0.3px;
        color: #888;
        text-transform: uppercase;
        text-decoration: none;
        text-align: center;
      }

      &.active,
      &:hover {
        a {
          background: #EAEAEA;
          color:  #1A1B1B;
          border-radius: 8px;
        }
      }
    }
  }

  ${({ $brand }) => $brand == 'jackson' && `
    margin-top: 24px;
  `}
`;

interface Props {
  enableOnlineDealers: string | null;
  enableDistributors: string | null;
  enableDistributorsPage: string | null;
  enableServiceCenters: string | null;
  view: string;
  handleViewChange: (view: string) => void;
}

const DealerNav: React.FC<Props> = ({ enableOnlineDealers, enableDistributors, enableDistributorsPage, enableServiceCenters, view, handleViewChange }) => {
  const brand = useBrand(); 

  console.log('dealernav brand', brand);

  return (
    <DealerNavigation $brand={brand}>
      <TabContainer>
        {view === 'dealers' ? (
          <TabItemActive onClick={() => handleViewChange('dealers')} $brand={brand} >Dealers</TabItemActive>
        ) : (
          <TabItem onClick={() => handleViewChange('dealers')} $brand={brand}>Dealers</TabItem>
        )}

        {enableOnlineDealers && enableOnlineDealers === 'true' && (
          view === 'online' ? (
            <TabItemActive onClick={() => handleViewChange('online')} $brand={brand}>Online Dealers</TabItemActive>
          ) : (
            <TabItem onClick={() => handleViewChange('online')} $brand={brand}>Online Dealers</TabItem>
          )
        )}

        {enableDistributors && enableDistributors === 'true' && (
 
          enableDistributorsPage && enableDistributorsPage === 'true' ? (
            <a 
            href={`/pages/distributors`}
            rel="noopener noreferrer" 
            className="react-no-underline"
          >
            <TabItem $brand={brand}>Distributors</TabItem>
          </a>
          )
         : (
          view === 'distributors' ? (
            <TabItemActive onClick={() => handleViewChange('distributors')} $brand={brand}>Distributors</TabItemActive>
          ) : (
            <TabItem onClick={() => handleViewChange('distributors')} $brand={brand}>Distributors</TabItem>
          )
         )
        )}

        {enableServiceCenters && enableServiceCenters === 'true' && (
          view === 'service' ? (
            <TabItemActive onClick={() => handleViewChange('service')} $brand={brand}>Service Centers</TabItemActive>
          ) : (
            <TabItem onClick={() => handleViewChange('service')} $brand={brand}>Service Centers</TabItem>
          )
        )}
      </TabContainer>
    </DealerNavigation>
  );
};

export default DealerNav;
